<template>
  <form @submit.prevent="filter">
    <!-- <div class="display-grid-column"> -->
    <div class="my-form-row">
      <div class="my-form-col">
        <label for="code">Código</label>
        <fg-input
          id="code"
          name="code"
          class="w-100 m-0"
          type="text"
          v-model="code"
        >
        </fg-input>
      </div>
      <div class="my-form-col">
        <label for="kit">Título</label>
        <fg-input
          id="kit"
          name="kit"
          class="w-100 m-0"
          type="text"
          v-model="kit"
        >
        </fg-input>
      </div>
      <div class="my-form-col">
        <label for="responsible">Responsável</label>
        <fg-input
          id="responsible"
          name="responsible"
          class="w-100 m-0"
          type="text"
          v-model="responsible"
        >
        </fg-input>
      </div>
      <div v-if="!is_customer" class="my-form-col">
        <label for="customer">Integrador</label>
        <fg-input
          id="customer"
          name="customer"
          class="w-100 m-0"
          type="text"
          v-model="customer"
        >
        </fg-input>
      </div>
      <div class="my-form-col">
        <label for="endUser">Cliente</label>
        <fg-input
          id="endUser"
          name="endUser"
          class="w-100 m-0"
          type="text"
          v-model="endUser"
        >
        </fg-input>
      </div>
    </div>
    <div class="my-form-row">
      <div class="my-form-col">
        <label for="customer">Data de criação (Inicial)</label>
        <input class="form-control" type="date" v-model="startDate" />
      </div>
      <div class="my-form-col">
        <label for="customer">Data de criação (Final)</label>
        <input class="form-control" type="date" v-model="endDate" />
      </div>
      <div class="my-form-col">
        <my-select
          id="city"
          name="city"
          :options="status_options"
          selected_prop="id"
          label="name"
          title="Status"
          v-model="status"
        ></my-select>
      </div>
    </div>
    <!-- </div> -->
    <div class="row text-center d-flex justify-content-center">
      <button type="submit" class="btn btn-sm btn-primary">Filtrar</button>
    </div>
  </form>
</template>

<script>
import { DatePicker } from "element-ui";
export default {
  name: "filterOrders",
  components: {
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      code: null,
      kit: null,
      responsible: null,
      customer: null,
      startDate: null,
      endDate: null,
      endUser: null,
      status: null,
      status_options: [],
    };
  },
  async mounted() {
    this.status_options = [{id: 0, name: "Não filtrar"}, ...await this.$store.dispatch("order/status")];
  },
  methods: {
    filter() {
      this.$emit("handleRead", {
        url_filter: true,
        url_params: this.computed_form,
      });
    },
  },
  computed: {
    computed_form() {
      let form = {};
      if (!!this.code) {
        form.code = this.code;
      }
      if (!!this.kit) {
        form.kit = this.kit;
      }
      if (!!this.responsible) {
        form.responsible = this.responsible;
      }
      if (!!this.customer) {
        form.customer = this.customer;
      }
      if (!!this.startDate) {
        form.createdAt = this.startDate;
        if (!!this.endDate) {
          form.createdAt = `${this.startDate}_${this.endDate}`;
        }
      }
      if (!!this.endUser) {
        form.endUser = this.endUser;
      }
      if (!!this.status) {
        form.status = this.status;
      }
      return Object.keys(form).length ? form : null;
    },
  },
};
</script>

<style></style>
